import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { useMutation } from '@apollo/react-hooks';
import { Checkbox } from 'primereact/checkbox';
import { injectIntl } from 'react-intl';
import { TOGGLE_ALLOW_GLOBAL_FIELDS_SELF_REGISTRATION } from '../mutations';
import messages from '../intl-messages';
import { withGrowl } from '../../../../components/GrowlNotifications';
import { Loading } from '../../../../components/Loading';

const ManageAllowUseForSuperLinks = ({
  currentAccount, data, intl: { formatMessage }, growl,
}) => {
  const [useForSuperLinksAllowed, setUseForSuperLinksAllowed] = useState(false);

  const [toggleAllowUseForSuperLinks, toggleAllowUseForSuperLinksResult] = useMutation(
    TOGGLE_ALLOW_GLOBAL_FIELDS_SELF_REGISTRATION, { refetchQueries: ['getAccount'] },
  );

  useEffect(() => {
    setUseForSuperLinksAllowed(data.account.globalAriFieldsEnabledForSuperLinks);
  }, [data]);

  return (
    <div className="p-grid p-align-center" style={{ borderBottom: '1px dashed black' }}>
      <div className="p-col-12">
        <small>
          {formatMessage(messages.allowFieldUseForSuperLinks)}
        </small>

        <label htmlFor="cb-s" className="p-checkbox-label">
          {useForSuperLinksAllowed
            ? formatMessage(messages.allowLocalFieldUseYesLabel)
            : formatMessage(messages.allowLocalFieldUseNoLabel)}
        </label>

        {toggleAllowUseForSuperLinks.loading ? (<Loading />)
          : (
            <Checkbox
              style={{ marginLeft: '5px' }}
              inputId="cb-s"
              disabled={toggleAllowUseForSuperLinksResult.loading}
              checked={useForSuperLinksAllowed}
              onChange={() => {
                const input = {
                  accountId: currentAccount,
                  canUseAriFields: !useForSuperLinksAllowed,
                };
                setUseForSuperLinksAllowed(!useForSuperLinksAllowed);
                toggleAllowUseForSuperLinks({ variables: { input } })
                  .then(() => {
                    growl.show({
                      severity: 'success',
                      summary: formatMessage(messages.growlToggleUseInSuperLinkSuccessSummary),
                      detail: formatMessage(messages.growlToggleUseInSuperLinkSuccessDetail),
                      sticky: false,
                    });
                  })
                  .catch(() => {
                    setUseForSuperLinksAllowed(useForSuperLinksAllowed);
                    growl.show({
                      severity: 'error',
                      summary: formatMessage(messages.growlToggleAllowSubaccountsFieldUseSummary),
                      detail: formatMessage(messages.growlToggleAllowSubaccountsFieldUseFail),
                      sticky: true,
                    });
                  });
              }}
            />
          )}
      </div>
    </div>
  );
};

ManageAllowUseForSuperLinks.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  intl: PropTypes.objectOf(PropTypes.any).isRequired,
  growl: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withGrowl(injectIntl(ManageAllowUseForSuperLinks));
